// VIVA-353 — catalogo de reacciones de evento y de comentario de evento.
//
// UNA SOLA FUENTE DE VERDAD para las dos capas: la pantalla necesita el emoji y la
// etiqueta, y el servicio necesita el `idTipoReaccion` que viaja en el payload. Vive
// en `shared/` porque es lo unico que pueden importar las dos sin que la UI arrastre
// axios ni el servicio dependa de `app/`.
//
// LOS IDS NO SON UNA SUPOSICION: se midieron contra pre el 2026-09-09 llamando a
// `POST /api/reaccionar/evento` con 0..7. La respuesta trae el emoji que el backend
// asocia a cada tipo, y coincide exactamente con las cuatro reacciones de la
// historia:
//
//   1 -> 👍   2 -> ❤️   3 -> 🎉   4 -> 👀
//
// Fuera de ese rango el endpoint responde 400:
//   * `idTipoReaccion: 0`  -> "El tipo de reacción es obligatorio." OJO: el ejemplo
//     del swagger manda 0, y 0 NO es un valor valido.
//   * 5 en adelante        -> "No fue posible registrar la reacción."
export const EVENT_REACTION_TYPES = [
  { id: "megusta", idTipoReaccion: 1, emoji: "👍", es: "Me gusta", en: "Like" },
  { id: "meencanta", idTipoReaccion: 2, emoji: "❤️", es: "Me encanta", en: "Love" },
  { id: "meemociona", idTipoReaccion: 3, emoji: "🎉", es: "Me emociona", en: "Excited" },
  { id: "meinteresa", idTipoReaccion: 4, emoji: "👀", es: "Me interesa", en: "Interested" },
];

// El "me gusta" de la tarjeta de comentario no ofrece catalogo: es un solo boton que
// alterna, como el del feed. Cuando se presiona se manda el pulgar.
export const EVENT_COMMENT_REACTION_TYPE = 1;

// Clave de UI -> id numerico del backend, y al reves. Devuelven `null` en vez de un
// valor por omision: mandar un tipo que el usuario no eligio seria peor que no
// mandar nada, porque el backend lo registraria igual.
export const toEventReactionTypeId = (id) =>
  EVENT_REACTION_TYPES.find((tipo) => tipo.id === id)?.idTipoReaccion ?? null;

export const fromEventReactionTypeId = (idTipoReaccion) =>
  EVENT_REACTION_TYPES.find(
    (tipo) => tipo.idTipoReaccion === Number(idTipoReaccion)
  )?.id ?? null;
